import { Avatar as MuiAvatar, AvatarProps as MuiAvatarProps } from '@mui/material';

import { Nullable } from '@clearverify/types';

import { FileInfoFragment } from 'src/api';
import type { AlignTypeImageProcess, FitTypeImageProcess } from 'src/types/file';
import { processFilestackImage } from 'src/utils/file';

export type AvatarProps = Omit<MuiAvatarProps, 'src'> & {
  src: Nullable<FileInfoFragment | string>;
  width?: number;
  height?: number;
  fit?: FitTypeImageProcess;
  align?: AlignTypeImageProcess;
};

export const Avatar: React.FC<AvatarProps> = ({
  src,
  width,
  height,
  fit,
  align,
  ...avatarProps
}) => {
  const avatarDownloadUrl = processFilestackImage(src, width, height, fit, align);

  return <MuiAvatar src={avatarDownloadUrl} {...avatarProps} />;
};
